import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {EquipmentCardEnums} from '@namespaces/equipment.namespace';
import {SelectValueInterface} from '@interfaces/select-value.interface';

@Injectable()
export class EquipmentCalibrationExpirationStatusProvider {
    public data$ = new BehaviorSubject<SelectValueInterface[]>([
        {id: EquipmentCardEnums.CalibrationExpiredStatus.expired,     title: 'Поверка отсутствует'},
        {id: EquipmentCardEnums.CalibrationExpiredStatus.soon,        title: 'Менее 3-х месяцев'},
        {id: EquipmentCardEnums.CalibrationExpiredStatus.close,       title: 'Менее 1-го месяца'},
        {id: EquipmentCardEnums.CalibrationExpiredStatus.long,        title: 'Действующая поверка'},
    ]);
}
